<script>
import { Line, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'
import moment from 'moment'


Number.prototype.between = function(a, b) {
  let min = Math.min.apply(Math, [a, b]),
    max = Math.max.apply(Math, [a, b]);
  return this >= min && this <= max;
};


export default {
  extends: Line,
  props: ['height', 'options', 'chartData', 'period'],
  mixins: [mixins.reactiveProp],

  mounted () {
    const brandSuccess = getStyle('--success') || '#4dbd74'
    const brandInfo = getStyle('--info') || '#20a8d8'
    const brandDanger = getStyle('--danger') || '#f86c6b'

    let d = this.chartData;
    
    let messageCounts = {
      data: [],
      label: 'Messages Sent',
      borderColor: '#6f42c1',
      yAxisID: 'mcounts',
      fill: true,
      backgroundColor: 'rgb(111, 66, 193, 0.15)',  // same color but using RGB notation for opacity
      borderWidth: this.period == 'Week' || this.period == '2Weeks' ? 1.5 : 3,
      borderJoinStyle: 'miter'
    }

    let xAxisLabels = []
    let businessHourBoxAnnotations = []
    let boxAnnotationWindowStart = null
    let boxAnnotationWindowEnd = null
    let implicitlyStartedWindow = false
    let boxAnnotationBgColor = "rgba(32, 158, 216, 0.12)"
    const windowHourStart = 8
    const windowHourEnd = 17
    const windowDayStart = 1
    const windowDayEnd = 5

    let options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' }

    Object.keys(d).sort().forEach(function(key) {
      // add label
      let hourTime = moment.unix(key)
      // console.log(hourTime.format('MMM Do hA'))
      xAxisLabels.push(hourTime.format('MMM Do hA'))

      // handle case where chart starts after 9AM
      if(!implicitlyStartedWindow 
        && businessHourBoxAnnotations.length == 0 
        && (hourTime.hour() >= windowHourStart && hourTime.hour() < windowHourEnd) 
        && hourTime.day().between(windowDayStart, windowDayEnd)) {

        console.log('implicitly starting annotation window: ' + hourTime.format('MMM Do hA'))
        boxAnnotationWindowStart = hourTime.format('MMM Do hA')
        implicitlyStartedWindow = true
      }

      if(boxAnnotationWindowStart == null 
        && hourTime.hour() == windowHourStart && hourTime.day().between(windowDayStart, windowDayEnd)) {
        boxAnnotationWindowStart = hourTime.format('MMM Do hA')
      } else if(boxAnnotationWindowEnd == null && boxAnnotationWindowStart != null
        && hourTime.hour() == windowHourEnd && hourTime.day().between(windowDayStart, windowDayEnd)) {

        boxAnnotationWindowEnd = hourTime.format('MMM Do hA')
      }
      // console.log('box start: ' + boxAnnotationWindowStart)
      // console.log('box end: ' + boxAnnotationWindowEnd)

      if(boxAnnotationWindowStart != null && boxAnnotationWindowEnd != null) {
        businessHourBoxAnnotations.push({
          type: 'box',
          drawTime: 'beforeDatasetsDraw',
          xScaleID: 'x-axis-0',
          yScaleID: 'y-axis-0',
          xMin: boxAnnotationWindowStart,
          xMax: boxAnnotationWindowEnd,
          backgroundColor: boxAnnotationBgColor,
          borderWidth: 0
        })
        // console.log('created box annotation: ' + boxAnnotationWindowStart + ' to ' + boxAnnotationWindowEnd)
        // console.log('box start: ' + boxAnnotationWindowStart)
        // console.log('box end: ' + boxAnnotationWindowEnd)

        boxAnnotationWindowStart = null
        boxAnnotationWindowEnd = null
      }

      // now fill in data
      let row = d[key]
      messageCounts['data'].push(row.total_messages)

    })

    // close out any box annotation that might be open
    if(boxAnnotationWindowStart != null && boxAnnotationWindowEnd == null && xAxisLabels.length > 1) {
      businessHourBoxAnnotations.push({
        type: 'box',
        drawTime: 'beforeDatasetsDraw',
        xScaleID: 'x-axis-0',
        yScaleID: 'y-axis-0',
        xMin: boxAnnotationWindowStart,
        xMax: xAxisLabels[xAxisLabels.length -1],
        backgroundColor: boxAnnotationBgColor,
        borderWidth: 0
      })
    }

    this.renderChart({
      labels: xAxisLabels,
      datasets: [messageCounts]
    }, 
    // chart options
    {
      elements: {
        point: {
          radius: 0,
          hitRadius: 14, 
          hoverRadius: 8
        }
      },
      tooltips: {
        enabled: true,
        // custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: false,
        position: 'bottom'
      },
      scales: {
        xAxes: [{
          // stacked: true,
          gridLines: {
            drawOnChartArea: true
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 24 // this will need to be dynamic based on time window
          }
          
        }],
        yAxes: [{
          id: 'mcounts',
          position: 'left',
          ticks: {
            beginAtZero: true,
            precision: 0,
            fontColor: '#6f42c1',
            // max: Math.max.apply(Math, messageCounts.data) + 10
          },
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            // fontColor: '#6f42c1',
            labelString: 'Public Messages Sent'
          }
        }]
      },

      annotation: {
        annotations: businessHourBoxAnnotations
        // annotations: [{
        //   type: 'box',
        //   drawTime: 'beforeDatasetsDraw',
        //   xScaleID: "x-axis-0",
        //   yScaleID: "y-axis-0",
        //   xMin: "Mar 16th 3PM",
        //   xMax: "Mar 17th 4AM",
        //   // backgroundColor: "rgba(77, 189, 116, 0.18)",  // success
        //   backgroundColor: "rgba(23, 162, 184, 0.18)",
        //   // borderColor: "rgb(101, 33, 171)",
        //   borderWidth: 1,
        //   onClick: function(e) {
        //     console.log("Box", e.type, this);
        //   }
        // }]
      }
      

    })
        
  }
}
</script>
